import PavanEnterprises from './PavanEnterprises';
import './index.css';

export default function App() {
  return <PavanEnterprises />;
}
